export default "__VITE_ASSET__4df489cd__"